module.exports = __webpack_public_path__ + "static/media/file_type_xls.9ec0bb2a.svg";